__turbopack_context__.v({
  "className": "open_sans_2902d8af-module__RUvvFG__className",
  "variable": "open_sans_2902d8af-module__RUvvFG__variable",
});
